<template>
  <div class="common-search-filter">
    <!-- Applied filter/search toolbar -->
    <div v-if="anySearchOrFilterIsApplied && showClearFilterBar" class="chat-toolbar">
      <div class="flexBox">
        <p class="truncated-text" style="margin: 0;">{{ truncatedText }}</p>
        <button class="clear-filter-btn" @click="handleClearFilter">Clear filter</button>
      </div>
    </div>

    <!-- Search Filter Container (searchView / filterView) -->
    <div class="liveChatSearchBar" v-if="activeView == 'filterView' || activeView == 'searchView'">
      <!-- Search/Filter chip showing selected value -->
      <div class="searchByChips" v-show="searchVal !== '' && (searchModal || hasActiveSearch) && !filterModal">
        <span class="selectedChip search-chip-item">
          <span class="chip-label search-chip-label">
            <span class="filter-label">
              <VIcon v-if="searchValParts.label === 'First Name' || searchValParts.label === 'Last Name'" name="user-line" class="search-type-icon"></VIcon>
              <VIcon v-if="searchValParts.label === 'Email'" name="envelope-line" class="search-type-icon"></VIcon>
              <VIcon v-if="searchValParts.label === 'Mobile No.'" name="call-line" class="search-type-icon"></VIcon>
              <span v-if="searchValParts.label !== 'First Name' && searchValParts.label !== 'Last Name' && searchValParts.label !== 'Email' && searchValParts.label !== 'Mobile No.'" :title="searchVal === 'Custom Field' ? searchVal : undefined">{{ chipShortLabel }}</span>
              <VIcon v-if="!searchValParts.value" name="close-line" @click="handleClearFilter" class="closeIcon filter-close-icon"></VIcon>
            </span>
            <span class="filter-value" :class="searchValueColorClass" v-if="searchValParts.value">
              <span class="filter-value-text">{{ searchValParts.value }}</span>
              <VIcon name="close-line" @click="handleClearFilter" class="closeIcon filter-close-icon"></VIcon>
            </span>
          </span>
        </span>
      </div>
      <VIcon @click="() => { activeView = 'inboxView'; filterDiv(false); }" name="arrow-left-line" :size="-4" class="commonIcon"></VIcon>  
      <div :class="{searchChip: searchVal !== '' }" class="width100P">
        <div class="searchBar" :class="[activeView == 'searchView' && searchVal !== '' ? searchFilterClass : '']">
          <input v-model="userSearchValue" :placeholder="activeView == 'filterView' ? 'Filter by...' : searchVal == 'Mobile No.' ? '+19876543210': 'Search by...'" @keyup.enter="activeView == 'searchView' ? searchFilters() : searchByDiv(true)" aria-label="searchbar" maxlength="30" class="native-search-input" />
          <div class="searchContainer">
            <VIcon 
              name="search-line" 
              :size="-5"
              @click="!(!showSearchByTitle && anySearchOrFilterIsApplied) && (activeView == 'searchView' ? searchFilters() : searchByDiv(true))"
              :class="{ 'searchIcon cursorPointer': true, 'searchIconDisabled': !showSearchByTitle && anySearchOrFilterIsApplied }"
            ></VIcon>
            <VIcon name="filter-line" :size="-5" v-if="!anySearchOrFilterIsApplied && showFilterOptions" @click="filterDiv(true)" class="searchIcon cursorPointer"></VIcon>
          </div>
        </div>
      </div>
    </div>

    <!-- Search Filter options -->
    <div class="filterContainer" v-if="filterModal && activeView == 'filterView' && showFilterOptions">
      <div class="filtersSection" v-if="filterSections.assignedTo">
        <div class="title">Assigned To</div>
        <div class="filterAssigned">
          <div class="sections" @click="handleFilter('assigned_to', 'me', undefined, 'Assigned to me')" v-if="agentFocusedMode == false">
            Me
          </div>
          <div class="sections" @click="handleFilter('assigned_to', 'agent', undefined, 'Assigned to agent')" v-if="agentFocusedMode == false">
            Agent
          </div>
          <div class="sections" @click="handleFilter('assigned_to', 'bot', undefined, 'Assigned to bot')" v-if="agentFocusedMode == false">
            Bot
          </div>
          <div class="sections" @click="handleFilter('assigned_to', 'unassigned', undefined, 'Unassigned')" v-if="agentFocusedMode == false">
            Unassigned
          </div>
        </div>
      </div>
      <div class="filtersSection" v-if="filterSections.chatStatus">
        <div class="title">Chat Status</div>
        <div class="filterAssigned">
          <div class="sections" @click="handleFilter('chat_status', 'followup', undefined, 'Chat Status - Follow-up')">
            Follow-up
          </div>
          <div class="sections" @click="handleFilter('chat_status', 'resolved', undefined, 'Chat Status - Resolved')" v-if="agentFocusedMode == false">
            Resolved
          </div>
        </div>
      </div>
      <div class="filtersSection" v-if="filterSections.marketingOptIn">
        <div class="title">Marketing Opt-in Status</div>
        <div class="filterAssigned">
          <div class="sections" @click="handleFilter('subscription_status', 'opted_in', undefined, 'Opt-in Status: subscribed')">
            subscribed
          </div>
          <div class="sections" @click="handleFilter('subscription_status', 'no_status', undefined, 'Opt-in Status: No status')">
            No status
          </div>
          <div class="sections" @click="handleFilter('subscription_status', 'opted_out', undefined, 'Opt-in Status: unsubscribed')">
            unsubscribed
          </div>
        </div>
      </div>
      <div class="filtersSection" v-if="filterSections.channel && filteredChannels.length > 0">
        <div class="title">Channel</div>
        <!-- Search by Sales channel -->
        <div class="filterAssigned">
          <div
            v-for="channel in filteredChannels"
            :key="channel.key"
            class="img-sections"
            @click="selectChannel(channel)"
          >
            <img :src="channel.image" alt="channel" />
          </div>
        </div>
      </div>
    </div>

    <!-- Search By Options -->
    <div class="seachByContainer" v-show="searchModal && activeView == 'searchView' && !hasActiveSearch">
      <div class="filtersSection">
        <p v-show="showSearchByTitle" class="title ion-no-margin">Search By</p>
        <div class="searchFilters">
          <span class="search-chip" @click="searchVal = 'First Name'" :class="{ selectedChip: searchVal == 'First Name' }">First Name</span>
          <span class="search-chip" @click="searchVal = 'Last Name'" :class="{ selectedChip: searchVal == 'Last Name' }">Last Name</span>
          <span class="search-chip" @click="searchVal = 'Email'" :class="{ selectedChip: searchVal == 'Email' }">Email</span>
          <span class="search-chip" @click="searchVal = 'Mobile No.'" :class="{ selectedChip: searchVal == 'Mobile No.' }">Mobile number</span>
          <span class="search-chip" id="tag-chip" ref="tagChipRef" @click="openPopover('Tag', 'tagChipRef')" :class="{ selectedChip: searchVal == 'Tag' }">Tag</span>
          <span class="search-chip" id="custom-field-chip" ref="customFieldChipRef" @click="openPopover('Custom Field', 'customFieldChipRef')" :class="{ selectedChip: searchVal == 'Custom Field' }">Custom field</span>
          <span class="search-chip" v-if="showChannelSearch" id="channel-chip" ref="channelChipRef" @click="openPopover('Channel', 'channelChipRef')" :class="{ selectedChip: searchVal == 'Channel' }">Channel</span>
          <span class="search-chip" v-if="showSubscriptionSearch" id="subscription-chip" ref="subscriptionChipRef" @click="openPopover('Subscription', 'subscriptionChipRef')" :class="{ selectedChip: searchVal == 'Subscription' }">Opt-in Status</span>
          <span class="search-chip" v-if="showSegmentSearch" id="segment-chip" ref="segmentChipRef" @click="openPopover('Segment', 'segmentChipRef')" :class="{ selectedChip: searchVal == 'Segment' }">Segment</span>
        </div> 
      </div>
    </div>

    <!-- Filter popovers: teleported to <body> because Ionic's ion-router-outlet /
         ion-page set `contain: layout`, which makes them the containing block for
         position: fixed descendants (so the panels used to be offset by the
         split-pane sidebar) and lets the pages' `overflow: hidden` wrappers clip them. -->
    <Teleport to="body">
      <!-- Custom Field Popover -->
      <div v-if="customField && popoverOpen" class="native-popover-backdrop" @click="() => { popoverOpen = false; customField = false; customFieldDropdownOpen = false; }"></div>
      <div v-if="customField && popoverOpen" class="native-popover custom-field-popover" :class="{ 'expanded-popover': customFieldDropdownOpen }" :style="popoverPosition">
        <div class="customFilter">
          <div class="customValues">
            <p class="sub-title custPadding no-margin">Custom Field</p>
            <CustomDataFieldPicker 
              v-model="searchByCustomFieldKey" 
              :canAddNew="false"
              @dropdown-open="customFieldDropdownOpen = true"
              @dropdown-close="customFieldDropdownOpen = false"
            />
          </div>
          <div class="customValues">
            <p class="sub-title custPadding no-margin">Custom Field Value</p>
            <VTextField v-model="searchByCustomFieldText" aria-label="custom field value" :maxlength="25" placeholder="custom field value" appearance="ghost" class="vivid-input"></VTextField>
          </div>
          <VButton class="vvd-btn-primary vvd-btn-block customBttn" connotation="cta" appearance="filled" label="Search" :disabled="isSearchDisabled" @click="searchFilters" />
        </div>
      </div>

      <!-- Tag Popover -->
      <div v-if="tagPopoverOpen" class="native-popover-backdrop" @click="() => { tagPopoverOpen = false; }"></div>
      <div v-if="tagPopoverOpen" class="native-popover tag-popover" :style="popoverPosition">
        <CustomTagList :always-open="true" @tag-selected="handleTagSelection" />
      </div>

      <!-- Channel Search Popover -->
      <div v-if="showChannelSearch && channelPopoverOpen" class="native-popover-backdrop" @click="() => { channelPopoverOpen = false; }"></div>
      <div v-if="showChannelSearch && channelPopoverOpen" class="native-popover channel-popover" :style="popoverPosition">
        <div class="customFilter">
          <div class="customValues">
            <p class="sub-title custPadding no-margin">Select Channel</p>
            <div class="channel-options">
              <div
                v-for="channel in filteredChannels"
                :key="channel.key"
                class="channel-option"
                :class="{ 'channel-option-selected': searchByChannelText === channel.key }"
                @click="selectChannelSearch(channel)"
              >
                <img :src="channel.image" :alt="channel.label" class="channelOptionIcon" />
                <span>{{ channel.label }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Subscription Status Search Popover -->
      <div v-if="showSubscriptionSearch && subscriptionPopoverOpen" class="native-popover-backdrop" @click="() => { subscriptionPopoverOpen = false; }"></div>
      <div v-if="showSubscriptionSearch && subscriptionPopoverOpen" class="native-popover subscription-popover" :style="popoverPosition">
        <div class="customFilter">
          <div class="customValues">
            <p class="sub-title custPadding no-margin">Select Status</p>
            <div class="subscription-options">
              <div class="subscription-option" :class="{ 'subscription-option-selected': searchBySubscriptionStatus === '1' }" @click="selectSubscriptionSearch('1')">Subscribed</div>
              <div class="subscription-option" :class="{ 'subscription-option-selected': searchBySubscriptionStatus === '0' }" @click="selectSubscriptionSearch('0')">No status</div>
              <div class="subscription-option" :class="{ 'subscription-option-selected': searchBySubscriptionStatus === '-1' }" @click="selectSubscriptionSearch('-1')">Unsubscribed</div>
            </div>
          </div>
        </div>
      </div>

      <!-- Segment Search Popover -->
      <div v-if="showSegmentSearch && segmentPopoverOpen" class="native-popover-backdrop" @click="() => { segmentPopoverOpen = false; }"></div>
      <div v-if="showSegmentSearch && segmentPopoverOpen" class="native-popover segment-popover" :style="popoverPosition">
        <div class="customFilter">
          <div class="customValues">
            <p class="sub-title custPadding no-margin">Select Segment</p>
            <span v-if="segmentListLoading" class="sub-title">Loading Segments...</span>
            <VSearchableSelect
              v-else-if="segmentList && segmentList.length"
              aria-label="segment"
              appearance="ghost"
              class="vivid-input"
              fixed-dropdown
              placeholder="Search and select segment"
              :modelValue="searchBySegmentId"
              @update:modelValue="(val) => { searchBySegmentId = val; onSegmentChange(); }"
            >
              <VOption v-for="seg in segmentList" :key="seg.id" :value="seg.id" :text="seg.name" />
            </VSearchableSelect>
            <p v-else class="sub-title no-margin">No segments available</p>
          </div>
        </div>
      </div>
    </Teleport>

    <!-- Inbox View (default view with search bar + slot content) -->
    <div v-if="activeView == 'inboxView'">
      <div class="liveChatSearchBarParentContainer">
        <div class="liveChatSearchBar">
          <!-- Search chip showing active search type -->
          <div class="searchByChips inbox-search-chip" v-show="hasActiveSearch">
            <span class="selectedChip search-chip-item">
              <span class="chip-label search-chip-label">
                <span class="filter-label">
                  <VIcon v-if="searchValParts.label === 'First Name' || searchValParts.label === 'Last Name'" name="user-line" class="search-type-icon"></VIcon>
                  <VIcon v-if="searchValParts.label === 'Email'" name="envelope-line" class="search-type-icon"></VIcon>
                  <VIcon v-if="searchValParts.label === 'Mobile No.'" name="call-line" class="search-type-icon"></VIcon>
                  <span v-if="searchValParts.label !== 'First Name' && searchValParts.label !== 'Last Name' && searchValParts.label !== 'Email' && searchValParts.label !== 'Mobile No.'" :title="searchVal === 'Custom Field' ? searchVal : undefined">{{ chipShortLabel }}</span>
                  <VIcon v-if="!searchValParts.value" name="close-line" @click="handleClearFilter" class="closeIcon filter-close-icon"></VIcon>
                </span>
                <span class="filter-value" :class="searchValueColorClass" v-if="searchValParts.value">
                  <span class="filter-value-text">{{ searchValParts.value }}</span>
                  <VIcon name="close-line" @click="handleClearFilter" class="closeIcon filter-close-icon"></VIcon>
                </span>
              </span>
            </span>
          </div>
          <!-- Filter chip showing active filter -->
          <div class="searchByChips inbox-search-chip filter-chip" v-show="internalFilterVal && internalFilterVal.trim() !== ''">
            <span class="selectedChip filter-chip-item">
              <span class="chip-label filter-chip-label">
                <span class="filter-label" v-if="filterValParts.label">{{ filterValParts.label }}</span>
                <span class="filter-value" :class="filterValueColorClass">
                  <span class="filter-value-text">{{ filterValParts.value }}</span>
                  <VIcon name="close-line" @click="handleClearFilter" class="closeIcon filter-close-icon"></VIcon>
                </span>
              </span>
            </span>
          </div>
          <div class="searchBar" :class="[hasActiveSearch ? searchFilterClass : '']">
            <input value="" @focus="activeView = 'searchView'; searchModal = true" :placeholder="(internalFilterVal && internalFilterVal.trim() !== '') || hasActiveSearch ? '' : placeholder" aria-label="search" class="native-search-input" />
            <div class="searchContainer">
              <VIcon name="search-line" @click="searchByDiv(true)" class="searchIcon cursorPointer" :size="-5"></VIcon>
              <VIcon name="filter-line" v-if="!anySearchOrFilterIsApplied && showFilterOptions" @click="filterDiv(true)" class="searchIcon cursorPointer" :size="-5"></VIcon>
            </div>
          </div>
          <div v-if="showAddChat" class="cursorPointer" lines="none" @click="$emit('add-edit-modal')">
            <img src="@/resources/images/add-chat.svg" width="30" alt="add-chat" />
          </div>
        </div>
        <!-- Quick shortcut chips -->
        <div class="quickShortcuts" v-if="showQuickShortcuts && !anySearchOrFilterIsApplied && agentFocusedMode == false">
          <span class="shortcutChip" @click="handleFilter('chat_status', 'resolved', undefined, 'Chat Status - Resolved')" style="padding-top: 8px;">
            Resolved
          </span>
          <span 
            v-for="channel in filteredChannels" 
            :key="channel.key"
            @click="selectChannel(channel)" 
            class="shortcutChip channelChip"
          >
            <img :src="channel.image" alt="channel" class="channelIcon" />
          </span>
        </div>
      </div>
      <!-- Slot for content (customer list, etc.) -->
      <slot></slot>
    </div>

    <!-- Agent Filter Modal -->
    <VDialog
      v-if="filterByAgent"
      :open="filterByAgent"
      headline="Filter By assigned Agent"
      modal
      full-width-body
      @close="handleClearFilter"
      style="--dialog-min-inline-size: 500px; --dialog-max-inline-size: 600px;"
    >
      <template #body>
        <div v-if="allAgents.length > 0" class="section_container">
          <div class="vpb-10">
            <VTextField v-model="filterByAgentSearchVal" placeholder="Enter name to search" aria-label="Enter name" appearance="ghost" class="vivid-input"></VTextField>
          </div>
          <div v-if="agentsToShow.length > 0">
            <div v-for="thisRole in agentsToShow" :key="thisRole.id" class="agent-row">
              <div class="agent-info">
                <div class="agent-img-container">
                  <img :src="thisRole.picture && thisRole.picture.length ? thisRole.picture : fallbackImage" alt="fallback" />
                </div>
                <span class="sub-title">{{ thisRole.name }}</span>
              </div>
              <VButton class="vvd-btn-primary" connotation="cta" appearance="filled" label="Select" @click="handleFilter('assigned_to', 'agent', thisRole.id)"></VButton>
            </div>
          </div>
          <div v-else class="empty-state-center">
            <VEmptyState icon="search-line" headline="No agents found"> </VEmptyState>
          </div>
        </div>
        <div v-else class="empty-state-center">
          <VEmptyState icon="search-line" headline="No agents found">
            No agents available
          </VEmptyState>
        </div>
      </template>
    </VDialog>
  </div>
</template>

<script setup>
import { ref, computed, watch, nextTick, onBeforeUnmount } from 'vue'
import { useUIStore } from '@/stores/ui'
const chevronDownOutline = 'chevron-down-line';
import CustomTagList from './CustomTagList.vue'
import CustomDataFieldPicker from './CustomDataFieldPicker.vue'
import fallbackImage from '@/resources/images/page-inbox-human-support.svg'
import { queryClient } from '@/shared/queryClient'
const updateToast = (payload) => useUIStore().updateToast(payload);

// ── Props ─────────────────────────────────────────────────────────────────────
const props = defineProps({
  /** Whether any search or filter is currently applied (controlled by parent) */
  anySearchOrFilterIsApplied: { type: Boolean, default: false },
  /** Whether agent focused mode is active */
  agentFocusedMode: { type: Boolean, default: false },
  /** Array of connected channel objects: { key, label, image, isConnected } */
  filteredChannels: { type: Array, default: () => [] },
  /** Whether to show the add-chat button */
  showAddChat: { type: Boolean, default: false },
  /** Whether to show quick shortcut chips below the search bar */
  showQuickShortcuts: { type: Boolean, default: false },
  /** Whether to show the filter options (funnel icon + filter panel) */
  showFilterOptions: { type: Boolean, default: true },
  /** Configuration for which filter sections to display */
  filterSections: {
    type: Object,
    default: () => ({ assignedTo: true, chatStatus: true, marketingOptIn: true, channel: true }),
  },
  /** List of all agents for the "Assigned to agent" filter modal */
  allAgents: { type: Array, default: () => [] },
  /** Placeholder text for the inbox view search input */
  placeholder: { type: String, default: 'Search...' },
  /** Whether to show the "Clear filter" toolbar banner when a filter is applied */
  showClearFilterBar: { type: Boolean, default: true },
  /** Whether to show the "Search By" title above the search type chips */
  showSearchByTitle: { type: Boolean, default: true },
  /** Whether to show channel search chip */
  showChannelSearch: { type: Boolean, default: false },
  /** Whether to show subscription status search chip */
  showSubscriptionSearch: { type: Boolean, default: false },
  /** Whether to show segment search chip */
  showSegmentSearch: { type: Boolean, default: false },
  /** List of segments for the segment search popover: [{ id, name }] */
  segmentList: { type: Array, default: () => [] },
  /** Whether segments are still loading */
  segmentListLoading: { type: Boolean, default: false },
})

// ── Emits ─────────────────────────────────────────────────────────────────────
const emit = defineEmits(['search', 'filter', 'clear', 'add-edit-modal'])

// ── Template refs ─────────────────────────────────────────────────────────────
const tagChipRef = ref(null)
const customFieldChipRef = ref(null)
const channelChipRef = ref(null)
const subscriptionChipRef = ref(null)
const segmentChipRef = ref(null)

// ── View state ────────────────────────────────────────────────────────────────
const activeView = ref('inboxView')
const searchModal = ref(false)
const filterModal = ref(false)

// ── Search state ──────────────────────────────────────────────────────────────
const searchVal = ref('First Name')
const userSearchValue = ref('')
const searchByFirstNameText = ref('')
const searchByLastNameText = ref('')
const searchByEmailText = ref('')
const searchByMobileNumberText = ref('')
const searchByTagText = ref('')
const searchByCustomFieldKey = ref('')
const searchByCustomFieldText = ref('')

// ── Filter display value ──────────────────────────────────────────────────────
const internalFilterVal = ref(undefined)

// ── Popover state ─────────────────────────────────────────────────────────────
const customField = ref(false)
const popoverOpen = ref(false)
const tagPopoverOpen = ref(false)
const customFieldDropdownOpen = ref(false)
const popoverPosition = ref({ top: '0px', left: '0px' })
const activePopoverTriggerRef = ref(null)

// ── Agent filter modal state ──────────────────────────────────────────────────
const filterByAgent = ref(false)
const filterByAgentSearchVal = ref(undefined)

// ── Channel search state ──────────────────────────────────────────────────────
const channelPopoverOpen = ref(false)
const searchByChannelText = ref('')

// ── Subscription search state ─────────────────────────────────────────────────
const subscriptionPopoverOpen = ref(false)
const searchBySubscriptionStatus = ref('')

// ── Segment search state ──────────────────────────────────────────────────────
const segmentPopoverOpen = ref(false)
const searchBySegmentId = ref('')

// ── Popover positioning ───────────────────────────────────────────────────────
// Panel size budget, kept in sync with the .native-popover styles below.
const POPOVER_MAX_HEIGHT = 400
const POPOVER_MIN_HEIGHT = 150
const POPOVER_WIDTH = 285
const VIEWPORT_GAP = 8

const chipRefs = {
  tagChipRef,
  customFieldChipRef,
  channelChipRef,
  subscriptionChipRef,
  segmentChipRef,
}

const anyPopoverOpen = computed(() =>
  popoverOpen.value ||
  tagPopoverOpen.value ||
  channelPopoverOpen.value ||
  subscriptionPopoverOpen.value ||
  segmentPopoverOpen.value
)

function updatePopoverPosition() {
  const rect = activePopoverTriggerRef.value?.getBoundingClientRect?.()
  if (!rect) return

  const spaceBelow = window.innerHeight - rect.bottom - VIEWPORT_GAP
  const spaceAbove = rect.top - VIEWPORT_GAP
  const openUpwards = spaceBelow < Math.min(POPOVER_MAX_HEIGHT, spaceAbove) && spaceAbove > spaceBelow

  let left = rect.left
  // Keep the panel inside the viewport on both edges.
  if (left + POPOVER_WIDTH > window.innerWidth) left = window.innerWidth - POPOVER_WIDTH - VIEWPORT_GAP
  if (left < VIEWPORT_GAP) left = VIEWPORT_GAP

  popoverPosition.value = {
    left: `${left}px`,
    maxHeight: `${Math.max(Math.min(POPOVER_MAX_HEIGHT, openUpwards ? spaceAbove : spaceBelow), POPOVER_MIN_HEIGHT)}px`,
    ...(openUpwards
      ? { top: 'auto', bottom: `${window.innerHeight - rect.top + VIEWPORT_GAP}px` }
      : { top: `${rect.bottom + VIEWPORT_GAP}px`, bottom: 'auto' }),
  }
}

function handlePopoverViewportChange() {
  if (anyPopoverOpen.value) updatePopoverPosition()
}

function removePopoverViewportListeners() {
  window.removeEventListener('resize', handlePopoverViewportChange)
  // Capture phase: the real scroller is ion-content's shadow .inner-scroll, not window.
  window.removeEventListener('scroll', handlePopoverViewportChange, true)
}

watch(anyPopoverOpen, (isOpen) => {
  if (isOpen) {
    window.addEventListener('resize', handlePopoverViewportChange)
    window.addEventListener('scroll', handlePopoverViewportChange, true)
    return
  }
  activePopoverTriggerRef.value = null
  removePopoverViewportListeners()
})

onBeforeUnmount(removePopoverViewportListeners)

// ── Constants ─────────────────────────────────────────────────────────────────
const MAX_TEXT_LENGTH = 30

// ── Computed ──────────────────────────────────────────────────────────────────
const isSearchDisabled = computed(() => {
  const isCustomSearch = !!searchByCustomFieldKey.value.trim() && !!searchByCustomFieldText.value.trim()
  const isNormalSearch =
    !!searchByFirstNameText.value.trim() ||
    !!searchByLastNameText.value.trim() ||
    !!searchByEmailText.value.trim() ||
    !!searchByTagText.value.trim() ||
    !!searchByMobileNumberText.value.trim()
  return !isCustomSearch && !isNormalSearch
})

const hasActiveSearch = computed(() =>
  searchByFirstNameText.value !== '' ||
  searchByLastNameText.value !== '' ||
  searchByEmailText.value !== '' ||
  searchByMobileNumberText.value !== '' ||
  searchByTagText.value !== '' ||
  (searchByCustomFieldKey.value !== '' && searchByCustomFieldText.value !== '') ||
  searchByChannelText.value !== '' ||
  searchBySubscriptionStatus.value !== '' ||
  searchBySegmentId.value !== ''
)

const searchByText = computed(() => {
  if (internalFilterVal.value?.trim()) {
    return `Filter by: ${internalFilterVal.value}`
  } else if (searchByCustomFieldKey.value) {
    return `Search ${searchByCustomFieldKey.value} by: ${searchByCustomFieldText.value}`
  } else {
    const searchValue =
      searchByFirstNameText.value?.trim() ||
      searchByLastNameText.value?.trim() ||
      searchByEmailText.value?.trim() ||
      searchByTagText.value?.trim() ||
      searchByMobileNumberText.value?.trim()
    return `Search by: ${searchValue}`
  }
})

const truncatedText = computed(() =>
  searchByText.value.length > MAX_TEXT_LENGTH
    ? searchByText.value.slice(0, MAX_TEXT_LENGTH) + '...'
    : searchByText.value
)

const searchFilterClass = computed(() => {
  const val = searchVal.value
  if (val === 'First Name' || val === 'Last Name' || val === 'Email' || val === 'Mobile No.' || val === 'Tag' || val === 'Custom Field' ) return 'searchFilter-short'
  if (val === 'Subscription') return 'searchFilter-long'
  if (val === 'Channel' || val === 'Segment') return 'searchFilter-medium'
  return 'searchFilter'
})

const filterValParts = computed(() => {
  if (!internalFilterVal.value) return { label: '', value: '' }
  const val = internalFilterVal.value
  let label = ''
  let value = ''

  if (val.includes(':')) {
    const parts = val.split(':')
    label = parts[0].trim()
    value = parts[1] ? parts[1].trim() : ''
  } else if (val.includes(' - ')) {
    const parts = val.split(' - ')
    label = parts[0].trim()
    value = parts[1] ? parts[1].trim() : ''
  } else if (val.toLowerCase().includes(' to ')) {
    const parts = val.split(/ to /i)
    label = parts[0].trim() + ' to'
    value = parts[1] ? parts[1].trim() : ''
  } else {
    label = ''
    value = val
  }

  return { label, value }
})

const filterValueColorClass = computed(() => {
  const label = filterValParts.value.label.toLowerCase()
  const colorMap = [
    { cls: 'filter-value-cyan',    keywords: ['chat status', 'opt-in status', 'channel'] },
    { cls: 'filter-value-magenta', keywords: ['segment'] },
  ]
  return colorMap.find(({ keywords }) => keywords.some(k => label.includes(k)))?.cls ?? 'filter-value-purple'
})

const chipShortLabel = computed(() =>
  searchVal.value === 'Custom Field' ? 'Cus..' : searchVal.value
)

const searchValParts = computed(() => {
  const label = searchVal.value
  let value = ''

  if (searchByFirstNameText.value !== '') {
    value = searchByFirstNameText.value
  } else if (searchByLastNameText.value !== '') {
    value = searchByLastNameText.value
  } else if (searchByEmailText.value !== '') {
    value = searchByEmailText.value
  } else if (searchByMobileNumberText.value !== '') {
    value = searchByMobileNumberText.value
  } else if (searchByTagText.value !== '') {
    value = searchByTagText.value
  } else if (searchByCustomFieldKey.value && searchByCustomFieldText.value !== '') {
    value = `${searchByCustomFieldKey.value} | ${searchByCustomFieldText.value}`
  } else if (searchByChannelText.value !== '') {
    const ch = props.filteredChannels.find(c => c.key === searchByChannelText.value)
    value = ch ? ch.label : searchByChannelText.value
  } else if (searchBySubscriptionStatus.value !== '') {
    const statusMap = { '1': 'subscribed', '0': 'No status', '-1': 'unsubscribed' }
    value = statusMap[searchBySubscriptionStatus.value] || searchBySubscriptionStatus.value
  } else if (searchBySegmentId.value !== '') {
    const seg = props.segmentList.find(s => String(s.id) === String(searchBySegmentId.value))
    value = seg ? seg.name : String(searchBySegmentId.value)
  }

  return { label, value }
})

const searchValueColorClass = computed(() => {
  const type = searchVal.value
  const colorMap = [
    { cls: 'filter-value-magenta', types: ['Tag', 'Custom Field', 'Segment'] },
    { cls: 'filter-value-cyan',    types: ['Channel', 'Subscription'] },
  ]
  return colorMap.find(({ types }) => types.includes(type))?.cls ?? 'filter-value-purple'
})

const agentsToShow = computed(() => {
  if (!props.allAgents.length) return []
  const query = (filterByAgentSearchVal.value || '').toLowerCase()
  if (!query) return props.allAgents
  return props.allAgents.filter(agent => agent.name.toLowerCase().includes(query))
})

// ── View toggle methods ───────────────────────────────────────────────────────
function filterDiv(value) {
  if (value && !filterModal.value) {
    filterModal.value = true
    searchModal.value = false
    activeView.value = 'filterView'
  } else {
    filterModal.value = false
  }
}

function searchByDiv(value) {
  if (value && !searchModal.value) {
    searchModal.value = true
    filterModal.value = false
    activeView.value = 'searchView'
  } else {
    searchModal.value = false
  }
}

// ── Search methods ────────────────────────────────────────────────────────────
function searchFilters() {
  if (
    searchVal.value !== 'Custom Field' &&
    searchVal.value !== 'Tag' &&
    userSearchValue.value === ''
  ) {
    updateToast({ open: true, message: 'search text cannot be empty', type: 'danger' })
    userSearchValue.value = ''
    return
  }

  if (searchVal.value === 'Custom Field') {
    popoverOpen.value = false
    customField.value = false
    handleSearch()
    return
  }

  if (searchVal.value === 'Tag') {
    popoverOpen.value = false
    handleSearch()
    return
  }

  setSearchTextBySelection(searchVal.value)

  if (userSearchValue.value !== '') {
    handleSearch()
  }
}

function setSearchTextBySelection(val) {
  switch (val) {
    case 'First Name':
      searchByFirstNameText.value = userSearchValue.value
      break
    case 'Last Name':
      searchByLastNameText.value = userSearchValue.value
      break
    case 'Email':
      searchByEmailText.value = userSearchValue.value
      break
    case 'Mobile No.':
      searchByMobileNumberText.value = userSearchValue.value
      break
    case 'Tag':
      searchByTagText.value = userSearchValue.value
      break
  }
}

function handleSearch() {
  userSearchValue.value = ' '
  internalFilterVal.value = undefined

  if (searchVal.value !== 'First Name') searchByFirstNameText.value = ''
  if (searchVal.value !== 'Last Name') searchByLastNameText.value = ''
  if (searchVal.value !== 'Email') searchByEmailText.value = ''
  if (searchVal.value !== 'Tag') searchByTagText.value = ''
  if (searchVal.value !== 'Mobile No.') searchByMobileNumberText.value = ''
  if (searchVal.value !== 'Custom Field') {
    searchByCustomFieldKey.value = ''
    searchByCustomFieldText.value = ''
  }
  if (searchVal.value !== 'Channel') searchByChannelText.value = ''
  if (searchVal.value !== 'Subscription') searchBySubscriptionStatus.value = ''
  if (searchVal.value !== 'Segment') searchBySegmentId.value = ''

  searchModal.value = false
  popoverOpen.value = false
  tagPopoverOpen.value = false
  channelPopoverOpen.value = false
  subscriptionPopoverOpen.value = false
  segmentPopoverOpen.value = false
  customField.value = false
  activeView.value = 'inboxView'

  emit('search', {
    searchByFirstNameText: searchByFirstNameText.value,
    searchByLastNameText: searchByLastNameText.value,
    searchByEmailText: searchByEmailText.value,
    searchByMobileNumberText: searchByMobileNumberText.value,
    searchByTagText: searchByTagText.value,
    searchByCustomFieldKey: searchByCustomFieldKey.value,
    searchByCustomFieldText: searchByCustomFieldText.value,
    searchByChannelText: searchByChannelText.value,
    searchBySubscriptionStatus: searchBySubscriptionStatus.value,
    searchBySegmentId: searchBySegmentId.value,
    // Signal parent to reset filter-related state
    searchByAssignedToAgentText: '',
    searchByAssignedToAgentID: '',
    selectedChannel: 'all',
    searchByAssignedToMeText: false,
    searchByAssignedToBotText: false,
    searchByUnassignedConvoText: false,
    searchByFollowupText: false,
    searchByArchivedUsersText: false,
    subscriptionStatus: '',
  })
}

// ── Filter methods ────────────────────────────────────────────────────────────
function handleFilter(method, type, agentId, filterDisplayVal) {
  let skip = false
  searchVal.value = 'First Name'
  searchByFirstNameText.value = ''
  searchByLastNameText.value = ''
  searchByEmailText.value = ''
  searchByMobileNumberText.value = ''
  searchByTagText.value = ''

  if (filterDisplayVal !== undefined) {
    internalFilterVal.value = filterDisplayVal
  }

  const filterParams = {
    method,
    type,
    searchByFirstNameText: '',
    searchByLastNameText: '',
    searchByEmailText: '',
    searchByMobileNumberText: '',
    searchByTagText: '',
    searchByCustomFieldKey: '',
    searchByCustomFieldText: '',
    searchByAssignedToMeText: false,
    searchByAssignedToBotText: false,
    searchByAssignedToAgentText: '',
    searchByAssignedToAgentID: '',
    searchByUnassignedConvoText: false,
    searchByFollowupText: false,
    searchByArchivedUsersText: false,
    subscriptionStatus: '',
    selectedChannel: 'all',
  }

  switch (method) {
    case 'channel':
      filterParams.selectedChannel = type
      break
    case 'assigned_to':
      switch (type) {
        case 'me':
          filterParams.searchByAssignedToMeText = true
          break
        case 'agent':
          if (agentId) {
            filterParams.searchByAssignedToAgentID = agentId
            filterByAgent.value = false
            const agent = props.allAgents.find(e => e.id === agentId)
            if (agent) internalFilterVal.value = `Assigned to ${agent.name}`
          } else {
            filterByAgent.value = true
            skip = true
          }
          break
        case 'bot':
          filterParams.searchByAssignedToBotText = true
          break
        case 'unassigned':
          filterParams.searchByUnassignedConvoText = true
          break
      }
      break
    case 'chat_status':
      switch (type) {
        case 'followup':
          filterParams.searchByFollowupText = true
          break
        case 'resolved':
          filterParams.searchByArchivedUsersText = true
          break
      }
      break
    case 'subscription_status':
      switch (type) {
        case 'opted_in':
          filterParams.subscriptionStatus = '1'
          break
        case 'no_status':
          filterParams.subscriptionStatus = '0'
          break
        case 'opted_out':
          filterParams.subscriptionStatus = '-1'
          break
      }
      break
  }

  if (!skip) {
    filterModal.value = false
    activeView.value = 'inboxView'
    emit('filter', filterParams)
  }
}

function selectChannel(channel) {
  handleFilter('channel', channel.key, undefined, `Channel - ${channel.label}`)
}

// ── Clear methods ─────────────────────────────────────────────────────────────
function handleClearFilter() {
  const hadActiveFilter =
    hasActiveSearch.value ||
    userSearchValue.value?.trim() !== '' ||
    searchByCustomFieldKey.value !== '' ||
    searchByCustomFieldText.value !== '' ||
    internalFilterVal.value !== undefined

  searchVal.value = 'First Name'
  internalFilterVal.value = undefined
  filterByAgent.value = false
  userSearchValue.value = ''
  searchByFirstNameText.value = ''
  searchByLastNameText.value = ''
  searchByEmailText.value = ''
  searchByMobileNumberText.value = ''
  searchByTagText.value = ''
  searchByCustomFieldKey.value = ''
  searchByCustomFieldText.value = ''
  searchByChannelText.value = ''
  searchBySubscriptionStatus.value = ''
  searchBySegmentId.value = ''
  activeView.value = 'inboxView'

  if (hadActiveFilter) {
    emit('clear')
  }
}

// ── Popover methods ───────────────────────────────────────────────────────────
function openPopover(type, refName) {
  searchVal.value = type

  activePopoverTriggerRef.value = chipRefs[refName]?.value ?? null
  updatePopoverPosition()

  const popoverConfig = {
    'Tag': () => {
      queryClient.invalidateQueries({ queryKey: ['customer-tags'] })
      tagPopoverOpen.value = true
    },
    'Custom Field': () => {
      queryClient.invalidateQueries({ queryKey: ['custom-fields'] })
      customField.value = true
      popoverOpen.value = true
    },
    'Channel': () => {
      channelPopoverOpen.value = true
    },
    'Subscription': () => {
      subscriptionPopoverOpen.value = true
    },
    'Segment': () => {
      queryClient.invalidateQueries({ queryKey: ['segments'] })
      segmentPopoverOpen.value = true
    },
  }

  popoverConfig[type]?.()
  nextTick(updatePopoverPosition)
}

function confirmPopoverSearch(popoverKey) {
  const popoverStateMap = {
    channelPopoverOpen,
    subscriptionPopoverOpen,
    segmentPopoverOpen,
    tagPopoverOpen,
    popoverOpen,
  }
  if (popoverStateMap[popoverKey]) popoverStateMap[popoverKey].value = false
  handleSearch()
}

function handleTagSelection(data) {
  if (data.action === 'error') {
    updateToast({ open: true, message: data.message, type: 'danger' })
  } else if (data.action === 'searchRequested') {
    searchByTagText.value = data.value
    userSearchValue.value = data.value
    setSearchTextBySelection('Tag')
    tagPopoverOpen.value = false
    searchFilters()
  }
}

function selectChannelSearch(channel) {
  searchByChannelText.value = channel.key
  confirmPopoverSearch('channelPopoverOpen')
}

function selectSubscriptionSearch(status) {
  searchBySubscriptionStatus.value = status
  confirmPopoverSearch('subscriptionPopoverOpen')
}

function onSegmentChange() {
  if (!searchBySegmentId.value || searchBySegmentId.value === '') return
  confirmPopoverSearch('segmentPopoverOpen')
}

// ── Public API (exposed to parent via template ref) ───────────────────────────
function resetView() {
  activeView.value = 'inboxView'
}

defineExpose({ selectChannel, resetView })
</script>

<style scoped>
.filterContainer, .seachByContainer{
  margin: 0px 20px 15px 20px; 
  transition: all 700ms;
}
.filtersSection {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;
}
.filterAssigned .sections {
  border-radius: 20px;
  background: #ededed;
  padding: 10px;
  cursor: pointer;
  font-size: 14px;
  color: var(--gray-04);
}
.filterAssigned .img-sections {
  margin-bottom: 5px;
  cursor: pointer;
  background: #ededed;
  border-radius: 50%;
  width: 40px;
  height: 40px;
}
.filterAssigned .img-sections img{
  width: 25px;
  height: 25px;
  margin-top: 8px;
  margin-left: 8px;
  margin-right: auto;
}
.searchFilters{
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}
.search-chip {
  display: inline-flex;
  align-items: center;
  padding: 6px 14px;
  border-radius: 20px;
  background: var(--gray-02);
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  margin: 0;
}
.search-chip:hover {
  background: var(--purple-opac);
  color: var(--purple);
}
.search-chip.selectedChip {
  background: var(--purple);
  color: var(--white);
}
.clear-filter-btn {
  background: none;
  border: none;
  color: var(--black);
  font-size: 14px;
  cursor: pointer;
  font-weight: 500;
}
.clear-filter-btn:hover {
  color: var(--purple);
}
.vivid-input {
  background: var(--background-primary);
  border-radius: 5px;
  min-height: 40px;
  width: 100%;
}
.agent-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px solid var(--background-primary);
}
.agent-info {
  display: flex;
  align-items: center;
  gap: 12px;
}
.agent-img-container {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
}
.agent-img-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.liveChatSearchBarParentContainer{
  border-bottom: 1px solid var(--background-primary);
}
.liveChatSearchBar{
  background: var(--white);
  padding: 20px;
  position: sticky;
  top: 0;
  z-index: 10;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 15px;
  justify-content: space-between;
  border-right: 1px solid var(--background-primary);
}
.searchIcon {
  width: 23px;
  height: 23px;
  color: var(--gray-04);
}
.searchBar{
  display: flex;
  align-items: center;
  padding: 0px 15px 0px 15px;
  border-radius: 25px;
  margin: 0px;
  background: var(--background-primary);
  flex: 1 1 90%;
  position: relative;
}
.searchBar .native-search-input {
  flex: 1;
  border: none;
  background: transparent;
  outline: none;
  font-size: 14px;
  color: var(--black);
  font-weight: 400;
  padding: 10px 0;
  min-height: 36px;
}
.searchBar .native-search-input::placeholder {
  color: var(--gray-04);
}
.searchBar ion-input{
  font-size: 14px;
  color: var(--black);
  font-weight: 400;
}
.searchChip{
  position: relative;
}
.searchByChips {
  position: absolute;
  top: 50%;
  left: 62px;
  transform: translateY(-50%);
  z-index: 999;
  max-width: 280px;
}
/* Override left position for searchByChips in inbox view */
.searchByChips.inbox-search-chip {
  left: 24px;
}
/* Filter chip specific styles - larger size */
.searchByChips.filter-chip {
  max-width: 280px;
}
ion-chip.selectedChip.filter-chip-item, span.selectedChip.filter-chip-item {
  min-width: 100px;
  max-width: 280px;
  padding: 0 12px;
}
ion-chip.selectedChip.filter-chip-item ion-label.filter-chip-label,
span.selectedChip.filter-chip-item .filter-chip-label {
  max-width: 260px;
  font-size: 13px;
  overflow: visible;
  text-overflow: unset;
  white-space: nowrap;
}
ion-chip.selectedChip, span.selectedChip{
  --background: var(--purple);
  background: var(--purple);
  color: var(--white);
  height: 30px;
  min-width: 70px;
  max-width: 140px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0 8px;
  border-radius: 20px;
}
.searchByChips ion-chip.selectedChip, .searchByChips span.selectedChip{
  --background: var(--gray-04);
  background: var(--gray-04);
}
.searchByChips ion-chip.selectedChip.search-chip-item, .searchByChips span.selectedChip.search-chip-item{
  --background: transparent;
  background: transparent;
  padding: 0;
  max-width: 280px;
}
.searchByChips ion-chip.selectedChip.search-chip-item ion-label.search-chip-label,
.searchByChips span.selectedChip.search-chip-item .search-chip-label {
  max-width: 260px;
  font-size: 13px;
  overflow: visible;
  text-overflow: unset;
  white-space: nowrap;
}
.searchByChips.filter-chip ion-chip.selectedChip, .searchByChips.filter-chip span.selectedChip{
  --background: transparent;
  background: transparent;
  padding: 0;
}
ion-chip.selectedChip ion-label, span.selectedChip .chip-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 95px;
  flex: 1;
}
ion-chip, .search-chip{
  margin: 0px;
  color: var(--gray-04);
}
.searchFilter,
.searchFilter-long{
  padding-inline-start: 130px !important;
}
.searchFilter-medium{
  padding-inline-start: 100px !important;
}
.searchFilter-short{
  padding-inline-start: 74px !important;
}
.flexBox{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0px 10px;
}
.truncated-text {
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  max-width: 100%;
  font-size: 14px;
  font-weight: 400;
  color: var(--black);
}
.closeIcon{
  color: var(--white);
  font-size: 14px;
}
/* Native popover styles */
.native-popover-backdrop {
  position: fixed;
  inset: 0;
  z-index: 9999;
}
.native-popover {
  position: fixed;
  z-index: 10000;
  background: var(--white);
  border-radius: 8px;
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.15);
  width: 285px;
  max-height: 400px;
  overflow-y: auto;
}
.native-popover.expanded-popover {
  max-height: 380px;
}
.native-popover .customFilter {
  padding: 5px 5px 15px 5px;
}
.no-margin {
  margin: 0;
}
.customValues{
  padding: 10px;
}

.custPadding{
  padding-bottom: 5px;
}
.sub-title{
  font-size: 14px;
  color: var(--gray-04);
  font-weight: 400;
  line-height: 16px;
}
.customBttn{
  margin: 14px 10px 0px 10px;
  display: flex;
}
.chip-label{
  color: var(--white);
  font-size: 12px;
  font-weight: 400;
  line-height: 1.2;
}
.filter-label {
  vertical-align: middle;
  display: inline-block;
  background-color: var(--gray-04);
  color: var(--white);
  padding: 6px 10px;
  border-radius: 15px 0 0 15px;
  font-size: 12px;
  font-weight: 400;
}
/* When filter-label is standalone (no value), make it fully rounded */
.filter-label:only-child {
  border-radius: 15px;
}
.filter-value {
  vertical-align: middle;
  display: inline-flex;
  align-items: center;
  color: var(--white);
  padding: 6px 10px;
  border-radius: 0 15px 15px 0;
  font-size: 12px;
  font-weight: 400;
  position: relative;
  max-width: 120px;
}
/* When filter-value is standalone (no label), make it fully rounded */
.filter-value:only-child {
  border-radius: 15px;
}
.filter-value-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  min-width: 0;
}
.filter-value-cyan {
  background-color: var(--cyan);
}
.filter-value-purple {
  background-color: var(--purple);
}
.filter-value-magenta {
  background-color: var(--magenta);
}
.filter-close-icon {
  color: var(--white);
  font-size: 14px;
  margin-left: 6px;
  cursor: pointer;
  vertical-align: middle;
}
.search-type-icon {
  font-size: 13px;
  margin-right: 4px;
  vertical-align: middle;
  color: var(--white);
}
.searchContainer{
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
}
.searchIconDisabled {
  opacity: 0.35;
  cursor: not-allowed !important;
  pointer-events: none;
}

/* Quick shortcuts styles */
.quickShortcuts {
  padding: 0 20px 15px 20px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  background: var(--white);
  border-right: 1px solid var(--background-primary);
}

.shortcutChip {
  background: var(--background-primary);
  color: var(--gray-04);
  height: 32px;
  border-radius: 16px;
  margin: 0;
  padding: 0 12px;
  font-size: 13px;
  font-weight: 400;
  cursor: pointer;
  transition: all 0.2s ease;
}

.shortcutChip:hover {
  --background: var(--purple-opac);
  color: var(--purple);
}

.shortcutChip.channelChip {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0 12px;
}

.channelIcon {
  width: 18px;
  height: 18px;
  object-fit: contain;
}

.channel-options, .subscription-options {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.channel-option, .subscription-option {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  color: var(--gray-04);
  background: var(--background-primary);
  transition: background 0.2s;
}
.channel-option:hover, .subscription-option:hover {
  background: var(--purple-opac);
  color: var(--purple);
}
.channel-option-selected, .subscription-option-selected {
  background: var(--purple-opac) !important;
  color: var(--purple) !important;
  font-weight: 500;
}
.channelOptionIcon {
  width: 22px;
  height: 22px;
  object-fit: contain;
}
.slctOptions {
  border-radius: 5px;
  --background: var(--background-primary);
  min-height: 48px;
  --border-width: 0px;
  width: 100%;
}
/* Mobile responsive styles */
@media only screen and (max-width: 768px) {
  .searchByChips {
    left: 45px;
    max-width: 110px;
  }
  
  ion-chip.selectedChip {
    height: 28px;
    max-width: 110px;
    padding: 0 6px;
  }
  
  ion-chip.selectedChip ion-label {
    max-width: 70px;
    font-size: 11px;
  }
  
  .chip-label {
    font-size: 11px;
  }
  
  .closeIcon {
    font-size: 13px;
  }
  
  .searchFilter,
  .searchFilter-long {
    padding-inline-start: 90px !important;
  }
  
  .searchFilter-medium {
    padding-inline-start: 78px !important;
  }
  
  .searchFilter-short {
    padding-inline-start: 68px !important;
  }
}

@media only screen and (max-width: 480px) {
  .searchByChips {
    left: 40px;
    max-width: 90px;
  }
  
  ion-chip.selectedChip {
    height: 26px;
    max-width: 90px;
    padding: 0 5px;
  }
  
  ion-chip.selectedChip ion-label {
    max-width: 55px;
    font-size: 10px;
  }
  
  .chip-label {
    font-size: 10px;
  }
  
  .closeIcon {
    font-size: 12px;
  }
  
  .searchFilter,
  .searchFilter-long {
    padding-inline-start: 75px !important;
  }
  
  .searchFilter-medium {
    padding-inline-start: 68px !important;
  }
  
  .searchFilter-short {
    padding-inline-start: 60px !important;
  }
}
.section_container{
  padding: 0px 20px 20px 20px;
}
.empty-state-center {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  text-align: center;
}
.vvd-btn-block{
  padding: 0px 20px 0px 0px;
}
@media only screen and (max-width: 1200px) {
  .liveChatSearchBar{
    justify-content: flex-start;
  }
}
</style>
